import { render, staticRenderFns } from "./TacticalClipboardSvg.vue?vue&type=template&id=6f5ef77c&"
import script from "./TacticalClipboardSvg.vue?vue&type=script&lang=ts&"
export * from "./TacticalClipboardSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports